import React from 'react'
import styled, { css } from 'styled-components'

import PublishedCell from './PublishedCell'

import Table from 'components/Table'
import Tooltip from 'components/Tooltip'

import { screenSize } from 'styles/shared'
import { color } from 'styles/colors'

import Video, { ValidResourceTypes } from 'types/Resource'

type ResourceProps = {
  type: ValidResourceTypes
  resource: Video
}

type Props = {
  resource: Video
  onSuccessfulSubmission: () => void
  onClickEditResource:(val:ResourceProps)=>void
}

const WistiaVideoRow = ({ resource, onSuccessfulSubmission, onClickEditResource }: Props) => {
  if (resource == null) {
    return null
  }

  return (
    <S.TableRow key={resource.name}>
      <Tooltip title={'Click to view'} placement="top">
        <S.NameThumbnailCell>
          <S.ThumbnailLink
            href={resource.url}
            target="_blank"
            rel="noreferrer"
          >
            <S.ThumbnailImage
              src={'/img/play_thumbnail.svg'}
              alt={`${resource.name}-thumbnail`}
            />
          </S.ThumbnailLink>

          <S.NameCell>
            <S.AnchorLink
              href={resource.url}
              target="_blank"
              rel="noreferrer"
            >
              {resource.name}
            </S.AnchorLink>
          </S.NameCell>
        </S.NameThumbnailCell>
      </Tooltip>

      <S.DescriptionCell>
        {resource.description}
        <br />
        <i>{resource.duration} minutes</i>
      </S.DescriptionCell>
      <S.DateCell>{resource.wistiaUpdatedAt}</S.DateCell>

      <PublishedCell type="video" resource={resource} onSuccessfulSubmission={onSuccessfulSubmission} onClickEditResource={onClickEditResource} />
    </S.TableRow>
  )
}

export default WistiaVideoRow

const cellStyle = css`
  padding: 5px;

  @media ${screenSize.medium} {
    font-size: 12px;
    min-width: 120px;
  }
`

const S = {
  NameThumbnailCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: center;
    flex-basis: 25%;
  `,
  NameCell: styled(Table.Cell)`
    align-items: flex-start;
  `,
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex: 2;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-basis: 50%;
    padding-left: 15px;
  `,
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 20%;
    padding-left: 15px;
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
    border-bottom: 1px solid ${color('wistiaVideoTableRowBorder')};
    margin: 10px;
    @media ${screenSize.small} {
      align-items: flex-start;
    }
  `,
  ThumbnailImage: styled.img`
    max-height: 80px;

    @media ${screenSize.medium} {
      padding: 0 0 0 5px;
      max-height: 30px;
    }
  `,
  ThumbnailLink: styled.a`
    display: inline-flex;
  `,
  AnchorLink: styled.a`
    color: ${color('warrantyText')};
    font-weight: 500;
    text-decoration: none;

    &:hover {
      color: ${color('warrantyText')};
    }
  `
}
